// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/release-cloudweb-15171-133-6-0.202305101522/" + chunkId + ".js";
};